export * from "./switch.component";
